exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RestoreDeletedPatientsDialog__dialog___2pkBK {\n  padding-bottom: var(--vds-padding-md);\n}\n.RestoreDeletedPatientsDialog__content___3cXf1 {\n  max-height: 60vh;\n  overflow-y: auto;\n}\n", ""]);

// exports
exports.locals = {
	"dialog": "RestoreDeletedPatientsDialog__dialog___2pkBK",
	"content": "RestoreDeletedPatientsDialog__content___3cXf1"
};